module.exports = __webpack_public_path__ + "static/media/bluejays-ringer-mb-en.ad1bcc51.jpg";